var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getAnalyticsSessionId } from '../utils/analytics';
import { getMonthlyContinuityClient } from '../utils/monthlyContinuity';
var continuityEnabled = process.env.REACT_APP_TPH_CONTINUITY_CHECKOUT === 'true';
var resolveApiBaseUrl = function () {
    var _a;
    if (continuityEnabled)
        return '';
    var envApiUrl = process.env.REACT_APP_API_URL;
    if (envApiUrl && envApiUrl.trim().length > 0) {
        return envApiUrl.trim().replace(/\/$/, '');
    }
    if (typeof window !== 'undefined' && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.origin)) {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return "http://".concat(window.location.hostname, ":5050");
        }
        return window.location.origin.replace(/\/$/, '');
    }
    return '';
};
var API_BASE_URL = resolveApiBaseUrl();
function toMonthlySubscriptionSnapshot(payload) {
    var subscriptions = Array.isArray(payload.subscriptions)
        ? payload.subscriptions
        : [];
    var fallbackSubscription = (payload.subscription || null);
    var billingEvents = Array.isArray(payload.billingEvents)
        ? payload.billingEvents
        : undefined;
    return {
        enabled: typeof payload.enabled === 'boolean'
            ? Boolean(payload.enabled)
            : true,
        enrollmentRequired: Boolean(payload.enrollmentRequired),
        accountSubscription: (payload.accountSubscription || null),
        profile: (payload.profile || null),
        subscription: fallbackSubscription || subscriptions[0] || null,
        subscriptions: subscriptions.length > 0
            ? subscriptions
            : (fallbackSubscription ? [fallbackSubscription] : []),
        offerEligibility: (payload.offerEligibility || null),
        paymentMethod: (payload.paymentMethod || null),
        paymentMethods: Array.isArray(payload.paymentMethods)
            ? payload.paymentMethods
            : [],
        billingEvents: billingEvents
    };
}
function generateIdempotencyKey(prefix) {
    var randomPart = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : "".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 10));
    return "".concat(prefix, "_").concat(randomPart);
}
function request(sessionToken, endpoint, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var headers, response, payload, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(continuityEnabled && options.method && options.method !== 'GET')) return [3 /*break*/, 3];
                    if (!endpoint.startsWith('/api/customer/profile')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, profile: true,
                            command: "profile:".concat(options.method, ":").concat(endpoint), path: endpoint, method: options.method,
                            input: options.body ? JSON.parse(String(options.body)) : {} })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    if (endpoint.startsWith('/api/customer/monthly/'))
                        throw Object.assign(new Error('This monthly action is temporarily unavailable.'), { code: 'CONTINUITY_MONTHLY_COMMAND_UNSUPPORTED' });
                    _a.label = 3;
                case 3:
                    headers = new Headers(options.headers || {});
                    headers.set('Authorization', "Bearer ".concat(sessionToken));
                    try {
                        headers.set('X-Analytics-Session-Id', getAnalyticsSessionId());
                    }
                    catch (_error) {
                        // Ignore analytics session header issues; request should still proceed.
                    }
                    if (!headers.has('Content-Type') && options.body) {
                        headers.set('Content-Type', 'application/json');
                    }
                    return [4 /*yield*/, fetch("".concat(API_BASE_URL).concat(endpoint), __assign(__assign(__assign({}, options), (continuityEnabled ? { credentials: 'same-origin', cache: 'no-store', redirect: 'error', referrerPolicy: 'origin' } : {})), { headers: headers }))];
                case 4:
                    response = _a.sent();
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 5:
                    payload = _a.sent();
                    if (!response.ok || !payload.success) {
                        errorMessage = (payload === null || payload === void 0 ? void 0 : payload.error) || (payload === null || payload === void 0 ? void 0 : payload.message) || "Request failed (".concat(response.status, ")");
                        throw new Error(String(errorMessage));
                    }
                    return [2 /*return*/, payload];
            }
        });
    });
}
export function getCustomerProfile(sessionToken) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/profile')];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function updateCustomerProfile(sessionToken, updates) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/profile', {
                        method: 'PUT',
                        body: JSON.stringify(updates)
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function createCustomerVehicle(sessionToken, vehicle) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/profile/vehicles', {
                        method: 'POST',
                        body: JSON.stringify(vehicle)
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function patchCustomerVehicle(sessionToken, vehicleId, updates) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, "/api/customer/profile/vehicles/".concat(vehicleId), {
                        method: 'PATCH',
                        body: JSON.stringify(updates)
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function deleteCustomerVehicle(sessionToken, vehicleId) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, "/api/customer/profile/vehicles/".concat(vehicleId), {
                        method: 'DELETE'
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function createCustomerDriver(sessionToken, driver) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/profile/drivers', {
                        method: 'POST',
                        body: JSON.stringify(driver)
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function patchCustomerDriver(sessionToken, driverId, updates) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, "/api/customer/profile/drivers/".concat(driverId), {
                        method: 'PATCH',
                        body: JSON.stringify(updates)
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function deleteCustomerDriver(sessionToken, driverId) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, "/api/customer/profile/drivers/".concat(driverId), {
                        method: 'DELETE'
                    })];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, payload.profile || null];
            }
        });
    });
}
export function getMonthlySubscription(sessionToken) {
    return __awaiter(this, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/subscription')];
                case 1:
                    payload = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(payload)];
            }
        });
    });
}
export function enrollMonthlySubscription(sessionToken, payload, tokenize) {
    return __awaiter(this, void 0, void 0, function () {
        var response_1, idempotencyKey, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!continuityEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, command: 'enroll', input: payload, tokenize: tokenize })];
                case 1:
                    response_1 = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response_1)];
                case 2:
                    idempotencyKey = payload.idempotencyKey || generateIdempotencyKey('enroll');
                    return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/enroll', {
                            method: 'POST',
                            headers: {
                                'X-Idempotency-Key': idempotencyKey
                            },
                            body: JSON.stringify(__assign(__assign({}, payload), { idempotencyKey: idempotencyKey }))
                        })];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function updateMonthlyPaymentMethod(sessionToken, sourceId, paymentMethodId, subscriptionId, idempotencyKey, tokenize) {
    if (idempotencyKey === void 0) { idempotencyKey = generateIdempotencyKey('payment_method'); }
    return __awaiter(this, void 0, void 0, function () {
        var normalizedSourceId, normalizedPaymentMethodId, response_2, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalizedSourceId = String(sourceId || '').trim();
                    normalizedPaymentMethodId = String(paymentMethodId || '').trim();
                    if (!normalizedSourceId && !normalizedPaymentMethodId && !(continuityEnabled && tokenize)) {
                        throw new Error('Either sourceId or paymentMethodId is required');
                    }
                    if (normalizedSourceId && normalizedPaymentMethodId) {
                        throw new Error('Provide either sourceId or paymentMethodId, not both');
                    }
                    if (!continuityEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, command: 'replace-card', tokenize: tokenize, input: __assign(__assign(__assign({}, (normalizedSourceId ? { sourceId: normalizedSourceId } : {})), (normalizedPaymentMethodId ? { paymentMethodId: normalizedPaymentMethodId } : {})), (subscriptionId ? { subscriptionId: subscriptionId } : {})) })];
                case 1:
                    response_2 = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response_2)];
                case 2: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/payment-method', {
                        method: 'POST',
                        headers: {
                            'X-Idempotency-Key': idempotencyKey
                        },
                        body: JSON.stringify({
                            sourceId: normalizedSourceId || undefined,
                            paymentMethodId: normalizedPaymentMethodId || undefined,
                            subscriptionId: subscriptionId,
                            idempotencyKey: idempotencyKey
                        })
                    })];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function removeMonthlyPaymentMethod(sessionToken, paymentMethodId) {
    return __awaiter(this, void 0, void 0, function () {
        var normalizedPaymentMethodId, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalizedPaymentMethodId = String(paymentMethodId || '').trim();
                    if (!normalizedPaymentMethodId) {
                        throw new Error('paymentMethodId is required');
                    }
                    return [4 /*yield*/, request(sessionToken, "/api/customer/monthly/payment-method/".concat(encodeURIComponent(normalizedPaymentMethodId)), {
                            method: 'DELETE'
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function cancelMonthlySubscription(sessionToken, subscriptionId) {
    return __awaiter(this, void 0, void 0, function () {
        var response_3, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!continuityEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, command: 'cancel',
                            input: subscriptionId ? { subscriptionId: subscriptionId } : { cancelAll: true } })];
                case 1:
                    response_3 = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response_3)];
                case 2: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/cancel', {
                        method: 'POST',
                        body: JSON.stringify(subscriptionId ? { subscriptionId: subscriptionId } : {})
                    })];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function assignMonthlySubscriptionVehicle(sessionToken, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/assign-vehicle', {
                        method: 'POST',
                        body: JSON.stringify(payload || {})
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function assignLotVehicle(sessionToken, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/assign-lot-vehicle', {
                        method: 'POST',
                        body: JSON.stringify(payload || {})
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function reduceMonthlySpots(sessionToken, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response_4, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!continuityEnabled) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, command: 'reduce-spots', input: payload })];
                case 1:
                    response_4 = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response_4)];
                case 2: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/reduce-spots', {
                        method: 'POST',
                        body: JSON.stringify(payload)
                    })];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function requestMonthlySpot(sessionToken, payload, tokenize) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _legacyKey, input, response_5, idempotencyKey, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!continuityEnabled) return [3 /*break*/, 2];
                    _a = payload || {}, _legacyKey = _a.idempotencyKey, input = __rest(_a, ["idempotencyKey"]);
                    return [4 /*yield*/, getMonthlyContinuityClient().execute({ sessionToken: sessionToken, command: 'request-spot', input: input, tokenize: tokenize })];
                case 1:
                    response_5 = _b.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response_5)];
                case 2:
                    idempotencyKey = (payload === null || payload === void 0 ? void 0 : payload.idempotencyKey) || generateIdempotencyKey('request_spot');
                    return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/request-spot', {
                            method: 'POST',
                            headers: {
                                'X-Idempotency-Key': idempotencyKey
                            },
                            body: JSON.stringify(__assign(__assign({}, (payload || {})), { idempotencyKey: idempotencyKey }))
                        })];
                case 3:
                    response = _b.sent();
                    return [2 /*return*/, toMonthlySubscriptionSnapshot(response)];
            }
        });
    });
}
export function requestAdditionalMonthlySpot(sessionToken, payload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, requestMonthlySpot(sessionToken, payload)];
        });
    });
}
export function verifyMonthlySubscriptionVehicle(sessionToken, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(sessionToken, '/api/customer/monthly/verify-vehicle', {
                        method: 'POST',
                        body: JSON.stringify(payload || {})
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            success: true,
                            belongsToCompany: Boolean(response.belongsToCompany),
                            actionRequired: Boolean(response.actionRequired),
                            message: String(response.message || ''),
                            unitType: (response.unitType || 'any'),
                            unitNumber: String(response.unitNumber || ''),
                            matchedVehicle: (response.matchedVehicle || null),
                            rosterSummary: (response.rosterSummary || null),
                            subscription: (response.subscription || null)
                        }];
            }
        });
    });
}
